module.exports = __webpack_public_path__ + "static/media/palliatieve-zorg-mannelijke-kunstenaar-in-atelier-large.c1ae585a.jpg";